<template>
  <div>
    <b-modal :id="modalId" size="lg" @hide="onClose" @show="clean">
      <b-overlay :show="isLoading" spinner-variant="primary" opacity="1">
        <label for="first-name">First name:</label>
        <b-form-input
          id="first-name"
          class="mb-3"
          v-model="userContent.firstName"
        ></b-form-input>

        <label for="last-name">Last name</label>
        <b-form-input
          id="last-name"
          class="mb-3"
          v-model="userContent.lastName"
        ></b-form-input>

        <label for="email">Email</label>
        <b-form-input
          id="email"
          class="mb-3"
          v-model="userContent.email"
        ></b-form-input>

        <label for="phone-number">Phone number</label>
        <b-form-input
          id="phone-number"
          class="mb-3"
          v-model="userContent.phoneNumber"
        ></b-form-input>

        <template v-if="isCreateMode">
          <label>Profile</label>
          <b-row>
            <b-col>
              <b-form-select
                v-model="selectedProfile"
                :options="profilesOptions"
                :disabled="!selectedTenant"
                :state="inputStates.profile"
              ></b-form-select
            ></b-col>
          </b-row>
        </template>
        <template>
          <b-card header="Credentials" class="mt-4">
            <b-card-text>
              <b-row>
                <b-col>
                  <label for="username">Username</label>
                  <b-form-input
                    id="username"
                    v-model="credentials.username"
                    :state="inputStates.username"
                  ></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col>
                  <label for="password">Password</label>
                  <b-form-input
                    id="password"
                    type="password"
                    v-model="credentials.password"
                    :state="inputStates.password"
                  ></b-form-input>
                </b-col>
              </b-row>
            </b-card-text>
          </b-card>
        </template>
      </b-overlay>
      <template v-slot:modal-header>
        <h2 v-if="isCreateMode">Create a new user</h2>
        <h2 v-else>
          User <code>{{ user._id }}</code> content
        </h2>
      </template>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="onClose">Close</b-button>
        <b-button
          type="submit"
          variant="primary"
          v-if="isCreateMode"
          @click="onCreate"
          >Create</b-button
        >
        <b-button type="submit" variant="primary" v-else @click="onUpdate"
          >Save</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'userContentModal',

  props: {
    user: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    },
    profiles: {
      type: Array
    },
    selectedTenant: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      selectedProfile: null,
      userContent: {
        firstName: null,
        lastName: null,
        email: null,
        phoneNumber: null
      },
      inputStates: {
        tenant: null,
        profile: null,
        username: null,
        password: null
      },
      credentials: {
        username: null,
        password: null
      },
      modalId: 'user-content-modal'
    };
  },

  computed: {
    isCreateMode() {
      return this.user._id ? false : true;
    },
    isFormValid() {
      if (this.isCreateMode) {
        return (
          this.inputStates.profile &&
          this.inputStates.username &&
          this.inputStates.password
        );
      } else {
        return this.inputStates.username;
      }
    },
    profilesOptions() {
      return [
        { value: null, text: 'Please select a profile' },
        ...this.profiles
      ];
    }
  },

  methods: {
    onClose() {
      this.$emit('modal-close');
      this.resetState();
      this.$bvModal.hide(this.modalId);
    },
    onUpdate() {
      this.validate();

      if (!this.isFormValid) {
        return;
      }

      const payload = {
        _id: this.user._id,
        _source: this.userContent,
        credentials: this.credentials
      };

      this.$emit('update', payload);
      this.$bvModal.hide(this.modalId);
    },
    onCreate() {
      this.validate();

      if (!this.isFormValid) {
        return;
      }

      const payload = {
        tenantId: this.selectedTenant._id || null,
        profile: this.selectedProfile || null,
        content: this.userContent,
        credentials: {
          local: this.credentials
        }
      };

      this.$emit('create', payload);
      this.$bvModal.hide(this.modalId);
    },
    clean() {
      if (!this.isCreateMode) {
        // Do not clean the form
        // if we are in edit mode
        return;
      }
      this.userContent = {
        firstName: null,
        lastName: null,
        email: null,
        phoneNumber: null
      };
      this.selectedProfile = null;
      this.credentials = {
        username: null,
        password: null
      };
    },
    resetState() {
      this.inputStates = {
        tenant: null,
        profile: null,
        username: null,
        password: null
      };
    },
    validate() {
      this.resetState();

      this.inputStates.username = this.credentials.username ? true : false;

      if (this.isCreateMode) {
        this.inputStates.profile = this.selectedProfile ? true : false;
        this.inputStates.password = this.credentials.password ? true : false;
      }
    }
  },
  watch: {
    user(value) {
      if (!this.isCreateMode && value) {
        this.userContent = {
          firstName: value._source.firstName || null,
          lastName: value._source.lastName || null,
          email: value._source.email || null,
          phoneNumber: value._source.phoneNumber || null
        };

        if (value.credentials) {
          this.credentials.username = value.credentials.username;
        }
      }
    }
  }
};
</script>

<style>
.tenant-badge {
  font-size: 1rem;
}
</style>
